import { gql } from "@apollo/client";
import { makeStyles, Typography } from "@material-ui/core";
import cx from "clsx";
import { OrganizationLogoFragment } from "generated/schemaTypes";
import { ResourceCustomTheme } from "styles/config";

type StyleProps = {
  color?: string;
};

const useStyles = makeStyles<ResourceCustomTheme, StyleProps>((_theme) => ({
  logoCont: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "3rem",
    height: 50,
  },
  logo: {
    maxHeight: 80,
    maxWidth: 160,
  },
  nameEmpty: {
    color: "rgba(0, 0, 0, 0.25)",
    fontSize: "2.375rem",
  },
  name: {
    color: "black",
    fontSize: "2.375rem",
  },
}));

const ORGANIZATION_FRAGMENT = gql`
  fragment OrganizationLogoFragment on Organization {
    companyLogoUrl
    name
  }
`;

type CompanyLogoProps = {
  organization: OrganizationLogoFragment;
  className?: string;
  theme?: {
    primaryColor: string;
    secondaryColor?: string | null;
  };
};

function CompanyLogo({
  organization,
  className = "",
  theme,
}: CompanyLogoProps) {
  const classes = useStyles({
    color: theme?.primaryColor,
  });
  const { companyLogoUrl, name: companyName } = organization;

  if (!companyLogoUrl) {
    return (
      <div className={cx(className, classes.logoCont)}>
        {companyName ? (
          <Typography variant="h2" className={classes.name}>
            {companyName}
          </Typography>
        ) : (
          <Typography variant="h2" className={classes.nameEmpty}>
            Company Name
          </Typography>
        )}
      </div>
    );
  }

  return companyLogoUrl ? (
    <div className={cx(className, classes.logoCont)}>
      <img
        src={companyLogoUrl || ""}
        alt={`${companyName} Logo`}
        className={classes.logo}
      />
    </div>
  ) : null;
}

CompanyLogo.fragments = {
  organization: ORGANIZATION_FRAGMENT,
};

export default CompanyLogo;
